import MarkerInfoBubble from "./MarkerInfoBubble"

export default  MarkerInfoBubble;


// WEBPACK FOOTER //
// ./src/common/components/Map/MarkerInfoBubble/index.js